import { render, staticRenderFns } from "./BusinessCoefficientUpdate.vue?vue&type=template&id=3a476cf0"
import script from "./BusinessCoefficientUpdate.vue?vue&type=script&lang=js"
export * from "./BusinessCoefficientUpdate.vue?vue&type=script&lang=js"
import style0 from "./BusinessCoefficientUpdate.vue?vue&type=style&index=0&id=3a476cf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports